/**
 * PLEASE do not use Mixins anymore,
 * If you are going to add a new method in this mixin consider UPGRADE THIS CODE to a high order component
 *
 */
const EditProfileMixins = {
    // the class approach did not work out
    _composite:function(obj){
        for (var prop in this) {
            if (Object.prototype.hasOwnProperty.call(this, prop) && (prop.charAt(0) !== '_')) {
                obj[prop]=this[prop];
            }
        }
        return obj;
    },
    deleteDialog:function(title, body, callback) {
        var popupHolder = $('body');
        var popupId = "popup-alert-container-" + Math.random().toString(36).substring(7);

        popupHolder.append('<div id="' + popupId + '">' + body + '</div>');
        popupHolder.find('#' + popupId).dialog({
            title: title,
            resizable: false,
            minWidth: 450,
            minHeight: 220,
            height: 'auto',
            modal: true,
            dialogClass: 'edit-profile-dialog delete-dialog people-js-react-modules-edit-profile-delete-dialog',
            buttons: {
                Delete: function () {
                    if (callback) {
                        callback();
                    }
                    $(this).dialog("close");
                },
                Cancel: function () {
                    $(this).dialog("close");
                }
            },
            close: function (event, ui) {
                $('#' + popupId).remove();
            }
        });
    },
    confirmDialog:function(title, body, callback) {
        var popupHolder = $('body');
        var popupId = "popup-alert-container-" + Math.random().toString(36).substring(7);

        popupHolder.append('<div id="' + popupId + '">' + body + '</div>');
        popupHolder.find('#' + popupId).dialog({
            title: title,
            resizable: false,
            minWidth: 450,
            minHeight: 220,
            height: 'auto',
            modal: true,
            dialogClass: 'edit-profile-dialog confirm-dialog people-js-react-modules-edit-profile-confirm-dialog',
            buttons: {
                OK: function () {
                    callback(true);
                    $(this).dialog("close");
                },
                Cancel: function () {
                    callback(false);
                    $(this).dialog("close");
                }
            },
            close: function (event, ui) {
                callback(false);
                $(this).dialog("close");
            }
        });

    },
    infoDialog:function(title, body) {
        var popupHolder = $('body');
        var popupId = "popup-alert-container-" + Math.random().toString(36).substring(7);
        if (body instanceof Array) {
            body = body.join('<br />');
        }

        popupHolder.append('<div id="' + popupId + '">' + body + '</div>');
        popupHolder.find('#' + popupId).dialog({
            title: title,
            resizable: false,
            minWidth: 450,
            minHeight: 220,
            height: 'auto',
            modal: true,
            dialogClass: 'edit-profile-dialog info-dialog people-js-react-modules-edit-profile-info-dialog',
            buttons: {
                Ok: function () {
                    $(this).dialog("close");
                }
            },
            close: function (event, ui) {
                $('#' + popupId).remove();
            }
        });
    },
    afterSaveSuccess:function() {
        // todo: Do based on module settings (popup or redirect)
        // window.location.reload();
        this.infoDialog(__d('people','Success'), __d('people','Your settings were successfully saved.'));
    },
    scrollToEl:function(el) {
        if (el && el.length > 0 && el.position() && el.position().top) {
            var topClearance = SS.tpl && SS.tpl.tplInfo && SS.tpl.tplInfo.fixedHeaderHeight ? SS.tpl.tplInfo.fixedHeaderHeight : 0;
            $("html, body").animate({scrollTop: parseInt(el.position().top - topClearance)}, 600);
        }
    }
};

// Semantic UI Checkbox
class EditProfileCheckbox extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        };
    }

    onValueChange(event) {
        this.setState({value: event.target.checked}, function () {
            this.props.onChange && this.props.onChange(this);
        }.bind(this));
    }

    setValue(checked) {
        this.setState({value: checked});
    }

    getValue() {
        return this.state.value;
    }

    render() {
        var field = React.createElement('input', {
            type: 'checkbox',
            name: this.props.name,
            id: this.props.id,
            checked: !!this.state.value,
            onChange: this.onValueChange.bind(this)
        });

        return (
            <div
                className={"field-group form-input-wrapper field-group-checkbox" + (this.props.cls ? ' ' + this.props.cls : '')}>
                <div className={"ui checkbox" + (!!this.state.value ? ' checked' : '')}>
                    {field}
                    <label htmlFor={this.props.id}>{this.props.label}</label>
                </div>
            </div>
        );
    }
}

EditProfileCheckbox.propTypes= {
    name: PropTypes.string,
        id: PropTypes.string,
        label: PropTypes.string,
        cls: PropTypes.string,
        value: PropTypes.any,
        onChange: PropTypes.func
};

EditProfileCheckbox.defaultProps = {
        name: 'checkbox',
        id: 'checkbox',
        label: null
};

class EditProfileAddressForm extends React.Component{
    // TODO: add mixing support
    constructor(props) {
        super(props);
        EditProfileMixins._composite(this);

        var locationCountryId = props.data.location_country_id;
        var locationStateId = props.data.location_state_id;

        this.state = {
            id: props.data.id,
            location_state_id: locationStateId,
            location_country_id: locationCountryId,
            stateParams: {
                location_country_id: locationCountryId
            },
            locationStateDisabled: !locationCountryId,
            address_type_id: props.data.address_type_id,
            address_type_label: props.data.PersonAddressType ? props.data.PersonAddressType.label : null
        };
    }

    isDefault() {
        return this.refs.field_default.getValue();
    }

    setDefault(v) {
        return this.refs.field_default.setValue(v);
    }

    save() {
        var data = {};
        this.props.fieldRefs.forEach(function (ref) {
            var field = this.refs['field_' + ref];
            if(field) {
                data[field.props.name] = field.getValue();
            }
        }.bind(this));

        // Set id for update, if not already set on hidden field
        if (!data.id && this.state.id) {
            data.id = this.state.id;
        }


        $.ajax({
            url: SS.route('People', 'PersonAddresses', 'save'),
            method: 'post',
            data: data,
            dataType: 'json',
            cache: false,
            success: function (data) {
                if (data.data && data.data.PersonAddress && data.data.PersonAddress.id) {
                    this.setState({
                        id: data.data.PersonAddress.id,
                        address_type_id: data.data.PersonAddress.address_type_id,
                        address_type_label: !parseInt(this.props.moduleSettings['hide_address_type']) ? this.refs.field_address_type.getText() : null
                    }, function () {
                        this.props.onSave && this.props.onSave(this, data.data.PersonAddress);
                        this.afterSaveSuccess();
                    }.bind(this));
                } else {
                    this.afterSaveSuccess();
                }
            }.bind(this),
            error: function (xhr, status, err) {
                var errorMessage = __d('people','Address could not be saved');
                var errorInfos = [];
                var response = xhr.responseJSON;
                if (response.errors) {
                    var errorKeys = Object.keys(response.errors);
                    errorKeys.forEach(function (error) {
                        response.errors[error].forEach(function (errorDetail) {
                            errorInfos.push(errorDetail);
                        })
                    })
                }
                if (errorInfos.length) {
                    errorMessage = errorInfos.join('<br />');
                }
                this.infoDialog(__d('people','Error'), errorMessage);
            }.bind(this)
        });
    }

    remove() {
        if (this.state.id) {
            this.deleteDialog(__d('people','Delete Confirmation'), __d('people','Are you sure you want to delete this Address?'), function () {
                $.ajax({
                    url: SS.route('People', 'PersonAddresses', 'delete'),
                    method: 'post',
                    data: {
                        id: this.state.id
                    },
                    dataType: 'json',
                    cache: false,
                    success: function (data) {
                        if (data.success) {
                            this.props.onRemoveButtonClick(this.props.index);
                        } else {
                            alert(__d('people','An Error Occurred'));
                        }
                    }.bind(this),
                    error: function (xhr, status, err) {
                        alert(__d('people','An Error Occurred'));
                    }
                });
            }.bind(this));
        } else {
            this.props.onRemoveButtonClick(this.props.index);
        }
    }

    onCountryChange(value) {
        var locationCountryId = value.value ? value.value : null;

        this.setState({
            stateParams: {
                location_country_id: locationCountryId
            },
            locationStateDisabled: !locationCountryId,
            location_state_id: null,
            location_country_id: locationCountryId
        });

        this.refs.field_state.clearValue();
    }

    onStateChange(value) {

    }

    onDefaultChange(comp) {
        if (!(comp.getValue() && this.props.totalCount > 1)) {
            return;
        }
        // If you're setting a default address and there are many addresses already entered
        this.confirmDialog(__d('people','Default Address'), __d('people','Are you sure you want to make this address the new default address?'), function (ok) {
            !ok && comp.setValue(false);
        }.bind(this));
    }

    render() {

        var props = this.props;
        var state = this.state;

        var addressFormId = props.addressFormId ? props.addressFormId : 0;

        return (
            <div className="edit-profile-sub-section edit-profile-sub-section-address" id={'edit-profile-address-form-' + addressFormId}>
                <div className="sub-section-title-holder">
                    <h3 className="sub-section-title">{__d('people','Address')}{state.address_type_label && !parseInt(props.moduleSettings['hide_address_type']) ?
                    ' (' + state.address_type_label + ')' : ''}</h3>

                    <div className="sub-section-buttons">
                        <a className="ui button add-section" href="#"
                           onClick={preventDef(function () {
                               props.onAddButtonClick()
                           }.bind(this))}
                           role="button"><i/><span>{__d('people','Add New')}</span></a>

                        <a className="ui button remove-section" href="#"
                           onClick={preventDef(this.remove.bind(this))}
                           role="button"><i/><span>{__d('people','Remove')}</span></a>

                        <div className="clearfix"></div>
                    </div>
                    <div className="clearfix"></div>
                </div>

                {props.data['has_associated_payment_method'] == true ?
                    <div className="payment-method-warning">
                        <div>{__d('people','This address is associated with one of your existing payment methods. Editing this address may affect future transactions.')}</div>
                    </div> : undefined}

                <div className="form-fields-holder">
                    <FieldHidden name="id" ref="field_id" value={state.id}/>
                    <FieldHidden name="person_id" ref="field_person_id" value={props.data['person_id']}/>

                    {!parseInt(props.moduleSettings['hide_address_type']) ?
                        <FieldDropdown name="address_type_id"
                                       ref="field_address_type"
                                       cls="address-type"
                                       label={__d('people','Type')}
                                       placeholder={__d('people','Type')}
                                       value={state.address_type_id}
                                       displayValue={state.address_type_label}
                                       url={SS.route('People', 'PersonAddressTypes', 'getAll')}
                                       idPath={['PersonAddressType', 'id']}
                                       displayPath={['PersonAddressType', 'label']}/> : undefined}

                    <FieldText name="address1" ref="field_address1" label={__d('people','Address 1')} placeholder={__d('people','Address 1')}
                               cls="address1" value={props.data['address1']}/>

                    {!parseInt(props.moduleSettings['hide_address_2_field']) ?
                        <FieldText name="address2" ref="field_address2" label={__d('people','Address 2')} placeholder={__d('people','Address 2')}
                                   cls="address2" value={props.data['address2']}/> : undefined}

                    <FieldDropdown name="location_country_id"
                                   ref="field_country"
                                   label={__d('people','Country')}
                                   placeholder={__d('people','Country')}
                                   cls="country"
                                   value={state.location_country_id}
                                   displayValue={props.data.LocationCountry ? props.data.LocationCountry.name : null}
                                   url={SS.route('Locations', 'LocationCountries', 'getAll')}
                                   idPath={['LocationCountry', 'id']}
                                   displayPath={['LocationCountry', 'name']}
                                   onChange={this.onCountryChange.bind(this)}/>

                    <FieldDropdown name="location_state_id"
                                   ref="field_state"
                                   label={__d('people','State')}
                                   cls="state"
                                   placeholder={state.locationStateDisabled ? __d('people','Select Country') : __d('people','State')}
                                   disabled={state.locationStateDisabled}
                                   value={state.location_state_id}
                                   displayValue={props.data.LocationState ? props.data.LocationState.name : null}
                                   url={SS.route('Locations', 'LocationStates', 'getAll')}
                                   urlParams={state.stateParams}
                                   idPath={['LocationState', 'id']}
                                   displayPath={['LocationState', 'name']}
                                   onChange={this.onStateChange.bind(this)}/>

                    <FieldText name="city" ref="field_city" label={__d('people','City')} placeholder={__d('people','City')} cls="city" value={props.data['city']}/>

                    <FieldText name="zip" ref="field_zip" label={__d('people','Zip')} placeholder={__d('people','Zip')} cls="zip" value={props.data['zip']}/>

                    <EditProfileCheckbox name="default"
                                         id={"default-address-" + addressFormId}
                                         ref="field_default"
                                         label={__d('people','Default Address')}
                                         cls="default-address"
                                         value={props.data['default']}
                                         onChange={this.onDefaultChange.bind(this)}/>

                    <div className="clearfix"></div>

                    <div className="form-validation-errors"></div>

                    <div className="form-actions">
                        <a className="ui button save" href="#" role="button" onClick={preventDef(this.save.bind(this))}>{__d('people','Save')}</a>
                    </div>
                </div>
            </div>
        );
    }
}



EditProfileAddressForm.propTypes = {
    addressFormId: PropTypes.number,
    onAddButtonClick: PropTypes.func,
    onRemoveButtonClick: PropTypes.func,
    data: PropTypes.object.isRequired,
    hideRemove: PropTypes.bool,
    totalCount: PropTypes.number,
    onSave: PropTypes.func
};

EditProfileAddressForm.defaultProps = {
    fieldRefs: [
        'id', 'person_id', 'address1', 'address2', 'country', 'state', 'city', 'zip', 'address_type', 'default'
    ]
};

class EditProfileAddresses extends React.Component{
    // TODO: add mixing support
    constructor(props) {
        super(props);
        EditProfileMixins._composite(this);
        this.state = {
            addresses: props.addresses
        };
    }

    add() {
        var addresses = this.state.addresses;
        var addressFormId = addresses.length + 1; // next id
        if (typeof this._newOnes == 'undefined') {
            this._newOnes = 0;
        }
        addresses.push({
            _new: true,
            _key: ++this._newOnes,
            person_id: this.props.personId,
            addressFormId: addressFormId
        });
        this.setState({
            addresses: addresses
        }, function () {
            // Scroll to newly added address
            this.scrollToEl($('#edit-profile-address-form-' + addressFormId));
        }.bind(this));
    }

    remove(index) {
        var addresses = this.state.addresses;
        delete(addresses[index]);
        this.setState({addresses: addresses});
    }

    onAddressSave(addrComp, data) {
        Object.assign(this.state.addresses[addrComp.props.index], data);
        delete this.state.addresses[addrComp.props.index]._new;

        this.state.addresses.forEach(function (a) {
            a.default = a.id != addrComp.state.id ? !addrComp.isDefault() : addrComp.isDefault();
        });

        var addr = this.sortAddresses(this.state.addresses);

        this.setState({addresses: addr}, function () {
            this.state.addresses.forEach(function (a) {
                var ref = "address-" + (a._key ? 'new-' + a._key : a.id);
                this.refs[ref].setDefault(a.default);
            }.bind(this));
        }.bind(this));
    }

    // sort addresses by default
    sortAddresses(addresses) {
        addresses.sort(function (a, b) {
            if (a.default) {
                return -1;
            }
            if (b.default) {
                return 1;
            }
            return 0;
        });
        return addresses;
    }

    render() {

        var props = this.props;
        var state = this.state;

        var addressFields = [];

        // Check if at least one phone exists
        // or if an empty form should be displayed
        var showAddresses = false;
        if (state.addresses) {
            $.each(state.addresses, function (name, value) {
                if (value && (value.id || value._new)) {
                    showAddresses = true;
                    return false;
                }
            })
        }

        if (showAddresses) {

            this.sortAddresses(state.addresses).forEach(function (record, key) {
                if (record) {
                    if (!record.addressFormId) {
                        record.addressFormId = key + 1;
                    }

                    addressFields.push(
                        <EditProfileAddressForm key={"address-" + (record._key ? 'new-' + record._key : record.id)}
                                                ref={"address-" + (record._key ? 'new-' + record._key : record.id)}
                                                index={key}
                                                moduleSettings={props.moduleSettings}
                                                addressFormId={record.addressFormId}
                                                data={record}
                                                onAddButtonClick={this.add.bind(this)}
                                                onRemoveButtonClick={this.remove.bind(this)}
                                                totalCount={state.addresses.length}
                                                onSave={this.onAddressSave.bind(this)}/>
                    );
                }
            }.bind(this));

        } else {

            addressFields = (
                <div className="empty-contact-details-section empty-contact-details-section-address">
                    <h3 className="sub-section-title">{__d('people','Address')}</h3>
                    <div className="empty-contact-details">
                        <i>{__d('people','You have no saved addresses')}</i>
                        <div className="add-item-holder">
                            <a href="#" onClick={preventDef(this.add.bind(this))}>{__d('people','Click here')}</a> <span>{__d('people','to add one.')}</span>
                        </div>
                    </div>
                </div>
            );

        }

        return (
            <div className="entities-holder addresses">
                {addressFields}
            </div>
        );
    }
}

EditProfileAddresses.propTypes= {
    personId: PropTypes.string.isRequired,
        moduleSettings: PropTypes.object.isRequired,
        addresses: PropTypes.array.isRequired
};

class EditProfilePhoneForm extends React.Component{
    // TODO: add mixing support
    constructor(props) {
        super(props);
        EditProfileMixins._composite(this);
        this.state = {
            id: props.data.id,
            phone_type_id: props.data.phone_type_id,
            phone_type_label: props.data.PersonPhoneType ? props.data.PersonPhoneType.label : null
        };
    }

    remove() {
        var state = this.state;
        var props = this.props;

        if (state.id) {
            this.deleteDialog(__d('people','Delete Confirmation'), __d('people','Are you sure you want to delete this Phone?'), function () {
                $.ajax({
                    url: SS.route('People', 'PersonPhones', 'delete'),
                    method: 'post',
                    data: {
                        id: this.state.id
                    },
                    dataType: 'json',
                    cache: false,
                    success: function (data) {
                        if (data.success) {
                            props.onRemoveButtonClick(props.index)
                        } else {
                            alert(__d('people','An Error Occurred'));
                        }
                    }.bind(this),
                    error: function (xhr, status, err) {
                        alert(__d('people','An Error Occurred'));
                    }
                });
            }.bind(this));
        } else {
            props.onRemoveButtonClick(props.index)
        }
    }

    save() {
        var data = {};

        var fieldRefs = this.props.fieldRefs;
        if(parseInt(this.props.moduleSettings['hide_phone_type'])){
            delete fieldRefs[fieldRefs.indexOf('phone_type')];
        }

        fieldRefs.forEach(function (ref) {
            var field = this.refs['field_' + ref];
            data[field.props.name] = field.getValue();
        }.bind(this));

        // Set id for update, if not already set on hidden field
        if (!data.id && this.state.id) {
            data.id = this.state.id;
        }

        if (this.refs['field_number'] !== undefined) {

            var phoneFieldValue = this.refs['field_number'].getValue();

            if (!phoneFieldValue || !phoneFieldValue.length) {
                this.infoDialog(__d('people','Error'), __d('people','Phone cannot be empty'));
                return false;
            }
        }

        $.ajax({
            url: SS.route('People', 'PersonPhones', 'save'),
            method: 'post',
            data: data,
            dataType: 'json',
            cache: false,
            success: function (data) {
                var stateUpdate = {};

                if (data.data && data.data.PersonPhone) {
                    if (!this.state.id && data.data.PersonPhone.id) {
                        stateUpdate['id'] = data.data.PersonPhone.id;
                    }
                    if (data.data.PersonPhone.phone_type_id) {
                        stateUpdate['phone_type_id'] = data.data.PersonPhone.phone_type_id;
                    }
                    if (!parseInt(this.props.moduleSettings['hide_phone_type']) && this.refs.field_phone_type.getText()) {
                        stateUpdate['phone_type_label'] = this.refs.field_phone_type.getText();
                    }
                }

                if (!$.isEmptyObject(stateUpdate)) {
                    this.setState(stateUpdate, function () {
                        this.afterSaveSuccess();
                    }.bind(this))
                } else {
                    this.afterSaveSuccess();
                }
            }.bind(this),
            error: function (xhr, status, err) {
                var errorMessage = __d('people','Phone number could not be saved');
                var errorInfos = [];
                var response = xhr.responseJSON;
                if (response.errors) {
                    var errorKeys = Object.keys(response.errors);
                    errorKeys.forEach(function (error) {
                        response.errors[error].forEach(function (errorDetail) {
                            errorInfos.push(errorDetail);
                        })
                    })
                }
                if (errorInfos.length) {
                    errorMessage = errorInfos.join('<br />');
                }
                this.infoDialog(__d('people','Error'), errorMessage);
            }.bind(this)
        });
    }

    render() {

        var props = this.props;
        var state = this.state;

        var phoneFormId = props.phoneFormId ? props.phoneFormId : 0;

        return (
            <div className="edit-profile-sub-section edit-profile-sub-section-phone" id={'edit-profile-phone-form-' + phoneFormId}>
                <div className="sub-section-title-holder">
                    <h3 className="sub-section-title">{__d('people','Phone')}{state.phone_type_label && !parseInt(props.moduleSettings['hide_phone_type']) ?
                    ' (' + state.phone_type_label + ')' : ''}</h3>

                    <div className="sub-section-buttons">
                        <a className="ui button add-section" href="#"
                           onClick={preventDef(function () {
                               props.onAddButtonClick()
                           }.bind(this))}
                           role="button"><i/><span>{__d('people','Add New')}</span></a>

                        <a className="ui button remove-section" href="#"
                           onClick={preventDef(this.remove.bind(this))}
                           role="button"><i/><span>{__d('people','Remove')}</span></a>

                        <div className="clearfix"></div>
                    </div>
                    <div className="clearfix"></div>
                </div>
                <div className="form-fields-holder">
                    <FieldHidden name="id" ref="field_id" value={state.id}/>
                    <FieldHidden name="person_id" ref="field_person_id" value={props.data['person_id']}/>

                    {!parseInt(props.moduleSettings['hide_phone_type']) ?
                        <FieldDropdown name="phone_type_id"
                                       ref="field_phone_type"
                                       cls="phone-type"
                                       label={__d('people','Type')}
                                       placeholder={__d('people','Type')}
                                       setDefault={true}
                                       value={state.phone_type_id}
                                       displayValue={state.phone_type_label}
                                       url={SS.route('People', 'PersonPhoneTypes', 'getAll')}
                                       idPath={['PersonPhoneType', 'id']}
                                       displayPath={['PersonPhoneType', 'label']}/> : undefined}

                    <FieldText name="number" ref="field_number" label={__d('people','Number')} placeholder={__d('people','Number')}
                               cls="number" value={props.data['number']}/>

                    <EditProfileCheckbox name="default"
                                         id={"default-phone-" + phoneFormId}
                                         ref="field_default"
                                         label={__d('people','Default Phone')}
                                         cls="default-phone"
                                         value={props.data['default']}/>

                    <EditProfileCheckbox name="is_outside_us"
                                         id={"is-outside-us-" + phoneFormId}
                                         ref="field_is_outside_us"
                                         label={__d('people','Outside US and Canada')}
                                         cls="is-outside-us"
                                         value={props.data['is_outside_us']}/>

                    <div className="clearfix"></div>

                    <div className="form-validation-errors"></div>

                    <div className="form-actions">
                        <a className="ui button save" href="#" role="button" onClick={preventDef(this.save.bind(this))}>{__d('people','Save')}</a>
                    </div>
                </div>
            </div>
        );
    }
}

EditProfilePhoneForm.propTypes = {
    phoneFormId: PropTypes.number,
    onAddButtonClick: PropTypes.func,
    onRemoveButtonClick: PropTypes.func,
    data: PropTypes.object.isRequired
};

EditProfilePhoneForm.defaultProps = {
    fieldRefs: [
        'id', 'person_id', 'number', 'default', 'phone_type', 'is_outside_us'
    ]
};

class EditProfilePhones extends React.Component{
    // TODO: add mixing support
    constructor(props) {
        super(props);
        EditProfileMixins._composite(this);
        this.state = {
            phones: props.phones
        };
    }

    add() {
        var phones = this.state.phones;
        var phoneFormId = phones.length + 1; // next id

        phones.push({
            _new: true,
            person_id: this.props.personId,
            phoneFormId: phoneFormId
        });
        this.setState({
            phones: phones
        }, function () {
            // Scroll to newly added phone
            this.scrollToEl($('#edit-profile-phone-form-' + phoneFormId));
        }.bind(this));
    }

    remove(index) {
        var phones = this.state.phones;
        delete(phones[index]);
        this.setState({phones: phones});
    }

    render() {

        var props = this.props;
        var state = this.state;

        var fields = [];

        // Check if at least one phone exists
        // or if an empty form should be displayed
        var showPhones = false;
        if (state.phones) {
            $.each(state.phones, function (name, value) {
                if (value && (value.id || value._new)) {
                    showPhones = true;
                    return false;
                }
            })
        }

        if (showPhones) {

            state.phones.forEach(function (record, key) {
                if (record) {
                    if (!record.phoneFormId) {
                        record.phoneFormId = key + 1;
                    }

                    fields.push(
                        <EditProfilePhoneForm key={"phone-" + key}
                                              index={key}
                                              phoneFormId={record.phoneFormId}
                                              moduleSettings={props.moduleSettings}
                                              data={record}
                                              onAddButtonClick={this.add.bind(this)}
                                              onRemoveButtonClick={this.remove.bind(this)}
                                              totalCount={state.phones.length}/>
                    );
                }
            }.bind(this));

        } else {

            fields = (
                <div className="empty-contact-details-section empty-contact-details-section-phone">
                    <h3 className="sub-section-title">{__d('people','Phone')}</h3>
                    <div className="empty-contact-details">
                        <i>{__d('people','You have no saved phones')}</i>
                        <div className="add-item-holder">
                            <a href="#" onClick={preventDef(this.add.bind(this))}>{__d('people','Click here')}</a> <span>{__d('people','to add one.')}</span>
                        </div>
                    </div>
                </div>
            );

        }

        return (
            <div className="entities-holder phones">
                {fields}
            </div>
        );
    }
}

EditProfilePhones.propTypes = {
    personId: PropTypes.string.isRequired,
    moduleSettings: PropTypes.object.isRequired,
    phones: PropTypes.array.isRequired
};

class EditProfileSocialNetworks extends React.Component{
    // TODO: add mixing support
    constructor(props) {
        super(props);
        EditProfileMixins._composite(this);
        this.state = {
            socialNetworks: props.socialNetworks
        };
    }

    add() {
        var socialNetworks = this.state.socialNetworks;
        var socialNetworkFormId = socialNetworks.length + 1; // next id

        socialNetworks.push({
            _new: true,
            person_id: this.props.personId,
            socialNetworkFormId: socialNetworkFormId
        });
        this.setState({
            socialNetworks: socialNetworks
        }, function () {
            // Scroll to newly added phone
            this.scrollToEl($('#edit-profile-social-network-form-' + socialNetworkFormId));
        }.bind(this));
    }

    remove(index) {
        var socialNetworks = this.state.socialNetworks;
        delete(socialNetworks[index]);
        this.setState({socialNetworks: socialNetworks});
    }

    render() {

        var props = this.props;
        var state = this.state;

        var fields = [];

        // Check if at least one phone exists
        // or if an empty form should be displayed
        var showSocialNetworks = false;
        if (state.socialNetworks) {
            $.each(state.socialNetworks, function (name, value) {
                if (value && (value.id || value._new)) {
                    showSocialNetworks = true;
                    return false;
                }
            })
        }

        if (showSocialNetworks) {

            state.socialNetworks.forEach(function (record, key) {
                if (record) {
                    if (!record.socialNetworkFormId) {
                        record.socialNetworkFormId = key + 1;
                    }

                    fields.push(
                        <EditProfileSocialNetworkForm
                            key={"social-network-" + key}
                            index={key}
                            socialNetworkFormId={record.socialNetworkFormId}
                            moduleSettings={props.moduleSettings}
                            data={record}
                            onAddButtonClick={this.add.bind(this)}
                            onRemoveButtonClick={this.remove.bind(this)}
                            totalCount={state.socialNetworks.length}/>
                    );
                }
            }.bind(this));

        } else {

            fields = (
                <div className="empty-contact-details-section empty-contact-details-section-social-network">
                    <h3 className="sub-section-title">{__d('people','Social Network')}</h3>
                    <div className="empty-contact-details">
                        <i>{__d('people','You have no saved social networks')}</i>
                        <div className="add-item-holder">
                            <a href="#" onClick={preventDef(this.add.bind(this))}>{__d('people','Click here')}</a> <span>{__d('people','to add one.')}</span>
                        </div>
                    </div>
                </div>
            );

        }

        return (
            <div className="entities-holder social-networks">
                {fields}
            </div>
        );
    }
}

EditProfileSocialNetworks.propTypes = {
    personId: PropTypes.string.isRequired,
        moduleSettings: PropTypes.object.isRequired,
        socialNetworks: PropTypes.array.isRequired
};

class EditProfileSocialNetworkForm extends React.Component{

    // TODO: add mixing support

    constructor(props) {
        super(props);
        EditProfileMixins._composite(this);
        this.state = {
            id: props.data.id,
            social_network_type_id: props.data.social_media_type_id,
            social_network_type_label: props.data.PersonSocialMediaType ? props.data.PersonSocialMediaType.label : null
        };
    }

    remove() {
        var state = this.state;
        var props = this.props;

        if (state.id) {
            this.deleteDialog(__d('people','Delete Confirmation'), __d('people','Are you sure you want to delete this Social Network?'), function () {
                $.ajax({
                    url: SS.route('People', 'PersonSocialNetworks', 'delete'),
                    method: 'post',
                    data: {
                        id: this.state.id
                    },
                    dataType: 'json',
                    cache: false,
                    success: function (data) {
                        if (data.success) {
                            props.onRemoveButtonClick(props.index)
                        } else {
                            alert(__d('people','An Error Occurred'));
                        }
                    }.bind(this),
                    error: function (xhr, status, err) {
                        alert(__d('people','An Error Occurred'));
                    }
                });
            }.bind(this));
        } else {
            props.onRemoveButtonClick(props.index)
        }
    }

    save() {
        var data = {};
        this.props.fieldRefs.forEach(function (ref) {
            var field = this.refs['field_' + ref];
            data[field.props.name] = field.getValue();
        }.bind(this));

        // Set id for update, if not already set on hidden field
        if (!data.id && this.state.id) {
            data.id = this.state.id;
        }

        $.ajax({
            url: SS.route('People', 'PersonSocialNetworks', 'save'),
            method: 'post',
            data: data,
            dataType: 'json',
            cache: false,
            success: function (data) {
                var stateUpdate = {};

                if (data.data && data.data.PersonSocialNetwork) {
                    if (!this.state.id && data.data.PersonSocialNetwork.id) {
                        stateUpdate['id'] = data.data.PersonSocialNetwork.id;
                    }
                    if (data.data.PersonSocialNetwork.social_media_type_id) {
                        stateUpdate['social_network_type_id'] = data.data.PersonSocialNetwork.social_media_type_id;
                    }
                    if (this.refs.field_social_network_type.getText()) {
                        stateUpdate['social_network_type_label'] = this.refs.field_social_network_type.getText();
                    }
                }

                if (!$.isEmptyObject(stateUpdate)) {
                    this.setState(stateUpdate, function () {
                        this.afterSaveSuccess();
                    }.bind(this));
                } else {
                    this.afterSaveSuccess();
                }
            }.bind(this),
            error: function (xhr, status, err) {
                var errorMessage = __d('people','Social network could not be saved');
                var errorInfos = [];
                var response = xhr.responseJSON;
                if (response.errors) {
                    var errorKeys = Object.keys(response.errors);
                    errorKeys.forEach(function (error) {
                        response.errors[error].forEach(function (errorDetail) {
                            errorInfos.push(errorDetail);
                        })
                    })
                }
                if (errorInfos.length) {
                    errorMessage = errorInfos.join('<br />');
                }
                this.infoDialog(__d('people','Error'), errorMessage);
            }.bind(this)
        });
    }

    render() {

        var props = this.props;
        var state = this.state;

        return (
            <div className="edit-profile-sub-section edit-profile-sub-section-social-network"
                 id={'edit-profile-social-network-form-' + (props.socialNetworkFormId ? props.socialNetworkFormId : '')}>
                <div className="sub-section-title-holder">
                    <h3 className="sub-section-title">{__d('people','Social Network')} {state.social_network_type_label ? ' (' + state.social_network_type_label + ')' : ''}</h3>

                    <div className="sub-section-buttons">
                        <a className="ui button add-section" href="#"
                           onClick={preventDef(function () {
                               props.onAddButtonClick()
                           }.bind(this))}
                           role="button"><i/><span>{__d('people','Add New')}</span></a>

                        <a className="ui button remove-section" href="#"
                           onClick={preventDef(this.remove.bind(this))}
                           role="button"><i/><span>{__d('people','Remove')}</span></a>

                        <div className="clearfix"></div>
                    </div>
                    <div className="clearfix"></div>
                </div>
                <div className="form-fields-holder">
                    <FieldHidden name="id" ref="field_id" value={state.id}/>
                    <FieldHidden name="person_id" ref="field_person_id" value={props.data['person_id']}/>

                    <FieldDropdown name="social_media_type_id"
                                   ref="field_social_network_type"
                                   cls="social-network-type"
                                   label={__d('people','Type')}
                                   placeholder={__d('people','Type')}
                                   setDefault={true}
                                   value={state.social_network_type_id}
                                   displayValue={state.social_network_type_label}
                                   url={SS.route('People', 'PersonSocialMediaTypes', 'getAll')}
                                   idPath={['PersonSocialMediaType', 'id']}
                                   displayPath={['PersonSocialMediaType', 'label']}/>

                    <FieldText name="name" ref="field_name" label="Name" placeholder="Name" cls="social-media-name"
                               value={props.data['name']}/>

                    <div className="clearfix"></div>

                    <div className="form-validation-errors"></div>

                    <div className="form-actions">
                        <a className="ui button save" href="#" role="button" onClick={this.save.bind(this)}>{__d('people','Save')}</a>
                    </div>
                </div>
            </div>
        );
    }
}

EditProfileSocialNetworkForm.propTypes = {
    socialNetworkFormId: PropTypes.number,
    onAddButtonClick: PropTypes.func,
    onRemoveButtonClick: PropTypes.func,
    data: PropTypes.object.isRequired
};

EditProfileSocialNetworkForm.defaultProps = {
    fieldRefs: [
        'id', 'person_id', 'name', 'social_network_type'
    ]
};

class EditProfileInstantMessengers extends React.Component{
    // TODO: add mixing support
    constructor(props) {
        super(props);
        EditProfileMixins._composite(this);
        this.state = {
            instantMessengers: props.instantMessengers
        };
    }

    add() {
        var instantMessengers = this.state.instantMessengers;
        var instantMessengerFormId = instantMessengers.length + 1; // next id

        instantMessengers.push({
            _new: true,
            person_id: this.props.personId,
            instantMessengerFormId: instantMessengerFormId
        });
        this.setState({
            instantMessengers: instantMessengers
        }, function () {
            // Scroll to newly added phone
            this.scrollToEl($('#edit-profile-instant-messenger-form-' + instantMessengerFormId));
        }.bind(this));
    }

    remove(index) {
        var instantMessengers = this.state.instantMessengers;
        delete(instantMessengers[index]);
        this.setState({instantMessengers: instantMessengers});
    }

    render() {

        var props = this.props;
        var state = this.state;

        var fields = [];

        // Check if at least one phone exists
        // or if an empty form should be displayed
        var showInstantMessengers = false;
        if (state.instantMessengers) {
            $.each(state.instantMessengers, function (name, value) {
                if (value && (value.id || value._new)) {
                    showInstantMessengers = true;
                    return false;
                }
            })
        }

        if (showInstantMessengers) {

            state.instantMessengers.forEach(function (record, key) {
                if (record) {
                    if (!record.instantMessengerFormId) {
                        record.instantMessengerFormId = key + 1;
                    }

                    fields.push(
                        <EditProfileInstantMessengerForm
                            key={"instant-messenger-" + key}
                            index={key}
                            instantMessengerFormId={record.instantMessengerFormId}
                            moduleSettings={props.moduleSettings}
                            data={record}
                            onAddButtonClick={this.add.bind(this)}
                            onRemoveButtonClick={this.remove.bind(this)}
                            totalCount={state.instantMessengers.length}/>
                    );
                }
            }.bind(this));

        } else {
            fields = (
                <div className="empty-contact-details-section empty-contact-details-section-instant-messenger">
                    <h3 className="sub-section-title">{__d('people','Instant Messenger')}</h3>
                    <div className="empty-contact-details">
                        <i>{__d('people','You have no saved instant messengers')}</i>
                        <div className="add-item-holder">
                            <a href="#" onClick={preventDef(this.add.bind(this))}>{__d('people','Click here')}</a> <span>{__d('people','to add one.')}</span>
                        </div>
                    </div>
                </div>
            );

        }

        return (
            <div className="entities-holder instant-messengers">
                {fields}
            </div>
        );
    }
}

EditProfileInstantMessengers.propTypes = {
    personId: PropTypes.string.isRequired,
    moduleSettings: PropTypes.object.isRequired,
    instantMessengers: PropTypes.array.isRequired
};

class EditProfileInstantMessengerForm extends React.Component{

    // TODO: add mixing support

    constructor(props) {
        super(props);
        EditProfileMixins._composite(this);
        this.state = {
            id: props.data.id,
            instant_messenger_type_id: props.data.instant_messenger_type_id,
            instant_messenger_type_label: props.data.PersonInstantMessengerType ? props.data.PersonInstantMessengerType.label : null
        };
    }

    remove() {
        var state = this.state;
        var props = this.props;

        if (state.id) {
            this.deleteDialog(__d('people','Delete Confirmation'), __d('people','Are you sure you want to delete this Instant Messenger?'), function () {
                $.ajax({
                    url: SS.route('People', 'PersonInstantMessengers', 'delete'),
                    method: 'post',
                    data: {
                        id: this.state.id
                    },
                    dataType: 'json',
                    cache: false,
                    success: function (data) {
                        if (data.success) {
                            props.onRemoveButtonClick(props.index)
                        } else {
                            alert(__d('people','An Error Occurred'));
                        }
                    }.bind(this),
                    error: function (xhr, status, err) {
                        alert(__d('people','An Error Occurred'));
                    }
                });
            }.bind(this));
        } else {
            props.onRemoveButtonClick(props.index)
        }
    }

    save() {
        var data = {};
        this.props.fieldRefs.forEach(function (ref) {
            var field = this.refs['field_' + ref];
            data[field.props.name] = field.getValue();
        }.bind(this));

        // Set id for update, if not already set on hidden field
        if (!data.id && this.state.id) {
            data.id = this.state.id;
        }

        $.ajax({
            url: SS.route('People', 'PersonInstantMessengers', 'save'),
            method: 'post',
            data: data,
            dataType: 'json',
            cache: false,
            success: function (data) {
                var stateUpdate = {};

                if (data.data && data.data.PersonInstantMessenger) {
                    if (!this.state.id && data.data.PersonInstantMessenger.id) {
                        stateUpdate['id'] = data.data.PersonInstantMessenger.id;
                    }
                    if (data.data.PersonInstantMessenger.instant_messenger_type_id) {
                        stateUpdate['instant_messenger_type_id'] = data.data.PersonInstantMessenger.instant_messenger_type_id;
                    }
                    if (this.refs.field_instant_messenger_type.getText()) {
                        stateUpdate['instant_messenger_type_label'] = this.refs.field_instant_messenger_type.getText();
                    }
                }

                if (!$.isEmptyObject(stateUpdate)) {
                    this.setState(stateUpdate, function () {
                        this.afterSaveSuccess();
                    }.bind(this))
                } else {
                    this.afterSaveSuccess();
                }
            }.bind(this),
            error: function (xhr, status, err) {
                var errorMessage = __d('people','Instant messenger could not be saved');
                var errorInfos = [];
                var response = xhr.responseJSON;
                if (response.errors) {
                    var errorKeys = Object.keys(response.errors);
                    errorKeys.forEach(function (error) {
                        response.errors[error].forEach(function (errorDetail) {
                            errorInfos.push(errorDetail);
                        })
                    })
                }
                if (errorInfos.length) {
                    errorMessage = errorInfos.join('<br />');
                }
                this.infoDialog(__d('people','Error'), errorMessage);
            }.bind(this)
        });
    }

    render() {

        var props = this.props;
        var state = this.state;

        return (
            <div className="edit-profile-sub-section edit-profile-sub-section-instant-messenger"
                 id={'edit-profile-instant-messenger-form-' + (props.instantMessengerFormId ? props.instantMessengerFormId : '')}>
                <div className="sub-section-title-holder">
                    <h3 className="sub-section-title">{__d('people','Instant Messenger')} {state.instant_messenger_type_label ? ' (' + state.instant_messenger_type_label + ')' : ''}</h3>

                    <div className="sub-section-buttons">
                        <a className="ui button add-section" href="#"
                           onClick={preventDef(function () {
                               props.onAddButtonClick()
                           }.bind(this))}
                           role="button"><i/><span>{__d('people','Add New')}</span></a>

                        <a className="ui button remove-section" href="#"
                           onClick={preventDef(this.remove.bind(this))}
                           role="button"><i/><span>{__d('people','Remove')}</span></a>

                        <div className="clearfix"></div>
                    </div>
                    <div className="clearfix"></div>
                </div>
                <div className="form-fields-holder">
                    <FieldHidden name="id" ref="field_id" value={state.id}/>
                    <FieldHidden name="person_id" ref="field_person_id" value={props.data['person_id']}/>

                    <FieldDropdown name="instant_messenger_type_id"
                                   ref="field_instant_messenger_type"
                                   label={__d('people','Type')}
                                   placeholder={__d('people','Type')}
                                   cls="instant-messenger-type"
                                   setDefault={true}
                                   value={state.instant_messenger_type_id}
                                   displayValue={state.instant_messenger_type_label}
                                   url={SS.route('People', 'PersonInstantMessengerTypes', 'getAll')}
                                   idPath={['PersonInstantMessengerType', 'id']}
                                   displayPath={['PersonInstantMessengerType', 'label']}/>

                    <FieldText name="name" ref="field_name" label={__d('people','Name')} placeholder={__d('people','Name')} cls="instant-messenger-name"
                               value={props.data['name']}/>

                    <div className="clearfix"></div>

                    <div className="form-validation-errors"></div>

                    <div className="form-actions">
                        <a className="ui button save" href="#" role="button" onClick={preventDef(this.save.bind(this))}>{__d('people','Save')}</a>
                    </div>
                </div>
            </div>
        );
    }
}

EditProfileInstantMessengerForm.propTypes = {
    instantMessengerFormId: PropTypes.number,
    onAddButtonClick: PropTypes.func,
    onRemoveButtonClick: PropTypes.func,
    data: PropTypes.object.isRequired
};

EditProfileInstantMessengerForm.defaultProps = {
    fieldRefs: [
        'id', 'person_id', 'name', 'instant_messenger_type'
    ]
};


class EditProfileBasicInformation extends React.Component{
    // TODO: add mixing support
    constructor(props){
        super(props);
        EditProfileMixins._composite(this);
    }

    save() {
        var data = {
            save_owner: 0,
            save_person_types: 0
        };
        var validationErrors = [];

        var requiredFields = ['firstname', 'lastname', 'email'];
        if (parseInt(this.props.moduleSettings['require_person_title'])) {
            requiredFields.push('title');
        }
        if (parseInt(this.props.moduleSettings['require_person_suffix'])) {
            requiredFields.push('suffix');
        }

        this.props.fieldRefs.forEach(function (ref) {
            var field = this.refs['field_' + ref];

            if (field !== undefined) {
                var alias = field.props.name;
                var value = field.getValue();
                data[alias] = value;

                if (requiredFields.indexOf(alias) > -1 && (!value || !value.length)) {
                    validationErrors.push(field.props.label + ' cannot be empty');
                }
            }
        }.bind(this));

        if (validationErrors.length) {
            this.infoDialog('Error', validationErrors.join('<br />'));
            return false;
        }

        $.ajax({
            url: SS.route('People', 'save'),
            method: 'post',
            data: data,
            dataType: 'json',
            cache: false,
            success: function (data) {
                this.afterSaveSuccess();
            }.bind(this),
            error: function (xhr, status, err) {

                var errorMessage = __d('people','Person data could not be saved');
                var errorInfos = [];
                var response = xhr.responseJSON;
                if (response.errors) {
                    var errorKeys = Object.keys(response.errors);
                    errorKeys.forEach(function (error) {
                        response.errors[error].forEach(function (errorDetail) {
                            errorInfos.push(errorDetail);
                        })
                    })
                }
                if (errorInfos.length) {
                    errorMessage = errorInfos.join('<br />');
                }
                this.infoDialog(__d('people','Error'), errorMessage);
            }.bind(this)
        });


    }

    render() {
        var personFields = [];

        // todo: Fix placeholders for dropdowns

        if (parseInt(this.props.moduleSettings['show_person_title_field'])) {
            personFields.push(<FieldDropdown name="title"
                                             ref="field_title"
                                             key="field_title"
                                             label={__d('people','Title')}
                                             placeholder={__d('people','Title')}
                                             cls="person-title"
                                             value={this.props.person['Person']['title']}
                                             displayValue={this.props.person['Person']['title']}
                                             url={SS.route('People', 'PersonTitles', 'getAll')}
                                             urlParams={{sort: [{"property": "label", "direction": "ASC"}]}}
                                             idPath={['PersonTitle', 'label']}
                                             displayPath={['PersonTitle', 'label']}
                                             singleSelect={true}/>);
        }

        var nameFields = this.props.moduleSettings.name_fields;

        var firstNameField = parseInt(nameFields['firstname']) ?
            <FieldText name="firstname" ref="field_firstname" key="field_firstname" label={__d('people','First Name')}
                       placeholder={__d('people','First Name')} cls="firstname" value={this.props.person['Person']['firstname']}/> : null;

        var lastNameField = parseInt(nameFields['lastname']) ?
            <FieldText name="lastname" ref="field_lastname" key="field_lastname" label={__d('people','Last Name')}
                       placeholder={__d('people','Last Name')} cls="lastname" value={this.props.person['Person']['lastname']}/> : null;

        // Group first name and last name if we are not showing middle name
        if (firstNameField && lastNameField && !parseInt(nameFields['middlename'])) {
            personFields.push(<div className="grouped-fields firstname-and-lastname" key="firstname-and-lastname">
                {firstNameField}
                {lastNameField}
                <div className="clearfix"></div>
            </div>);
        } else {
            if (firstNameField) {
                personFields.push(firstNameField);
            }
            if (parseInt(nameFields['middlename'])) {
                personFields.push(<FieldText name="middlename" ref="field_middlename" key="field_middlename"
                                             label={__d('people','Middle Name')} placeholder={__d('people','Middle Name')} cls="middlename"
                                             value={this.props.person['Person']['middlename']}/>);
            }
            if (lastNameField) {
                personFields.push(lastNameField);
            }
        }

        if (parseInt(nameFields['maidenname'])) {
            personFields.push(<FieldText name="maidenname" ref="field_maidenname" key="field_maidenname"
                                         label={__d('people','Maiden Name')} placeholder={__d('people','Maiden Name')} cls="maidenname"
                                         value={this.props.person['Person']['maidenname']}/>);
        }
        if (parseInt(nameFields['nickname'])) {
            personFields.push(<FieldText name="nickname" ref="field_nickname" key="field_nickname"
                                         label={__d('people','Preferred Name / Nickname')}
                                         placeholder={__d('people','Preferred Name / Nickname')} cls="nickname"
                                         value={this.props.person['Person']['nickname']}/>);
        }

        personFields.push(<FieldText name="email" ref="field_email" key="field_email" label={__d('people','Email')} placeholder={__d('people','Email')}
                                     cls="email" value={this.props.person['Person']['email']}/>);

        if (parseInt(this.props.moduleSettings.show_person_suffix_field)) {
            personFields.push(<FieldDropdown name="suffix"
                                             ref="field_suffix"
                                             key="field_suffix"
                                             label={__d('people','Suffix')}
                                             placeholder={__d('people','Suffix')}
                                             cls="person-suffix"
                                             value={this.props.person['Person']['suffix']}
                                             displayValue={this.props.person['Person']['suffix']}
                                             url={SS.route('People', 'PersonSuffixes', 'getAll')}
                                             urlParams={{sort: [{"property": "label", "direction": "ASC"}]}}
                                             idPath={['PersonSuffix', 'label']}
                                             displayPath={['PersonSuffix', 'label']}
                                             singleSelect={true}/>);
        }

        if (parseInt(this.props.moduleSettings.show_gender_field)) {
            personFields.push(<FormFieldSelect name="gender"
                                               ref="field_gender"
                                               key="field_gender"
                                               label={__d('people','Gender')}
                                               empty={__d('people','Gender')}
                                               cls="gender"
                                               value={this.props.person['Person']['gender']}
                                               options={{'m': __d('people','Male'), 'f': __d('people','Female')}}/>);
        }

        if (parseInt(this.props.moduleSettings.show_birthday_field)) {
            personFields.push(<FieldDate name="birthday"
                                         ref="field_birthday"
                                         key="field_birthday"
                                         label={__d('people','Birth Date')}
                                         placeholder={__d('people','Birth Date')}
                                         cls="birthday"
                                         value={this.props.person['Person']['birthday']}
                                         yearRange="c-150:c+0"
                                         formatGetValue={true}/>);
        }

        if (parseInt(this.props.moduleSettings.show_marital_status_fields)) {
            personFields.push(<FieldDropdown singleSelect={true}
                                             name="marital_status"
                                             ref="field_marital_status"
                                             key="field_marital_status"
                                             label={__d('people','Marital Status')}
                                             placeholder={__d('people','Marital Status')}
                                             cls="marital-status"
                                             value={this.props.person['Person']['marital_status']}
                                             displayValue={this.props.person['Person']['marital_status']}
                                             url={SS.route('People', 'PersonMaritalStatuses', 'getAll')}
                                             urlParams={{sort: [{"property": "id", "direction": "ASC"}]}}
                                             idPath={['PersonMaritalStatus', 'label']}
                                             displayPath={['PersonMaritalStatus', 'label']}/>);
            personFields.push(<FieldDate name="wedding_anniversary"
                                         ref="field_wedding_anniversary"
                                         key="field_wedding_anniversary"
                                         label={__d('people','Wedding Anniversary')}
                                         placeholder={__d('people','Wedding Anniversary')}
                                         cls="wedding-anniversary"
                                         value={this.props.person['Person']['wedding_anniversary']}
                                         yearRange="c-150:c+0"
                                         formatGetValue={true}/>);
        }

        if (parseInt(this.props.moduleSettings.show_shirt_size_field)) {
            personFields.push(<FieldDropdown singleSelect={true}
                                             name="shirt_size"
                                             ref="field_shirt_size"
                                             key="field_shirt_size"
                                             label={__d('people','Shirt Size')}
                                             placeholder={__d('people','Shirt Size')}
                                             cls="shirt-size"
                                             value={this.props.person['Person']['shirt_size']}
                                             displayValue={this.props.person['Person']['shirt_size']}
                                             url={SS.route('People', 'PersonShirtSizes', 'getAll')}
                                             urlParams={{sort: [{"property": "id", "direction": "ASC"}]}}
                                             idPath={['PersonShirtSize', 'label']}
                                             displayPath={['PersonShirtSize', 'label']}/>);
        }

        return (
            <div className="person-basic-information">
                <h2 className="person-basic-information-title">{__d('people','Personal Information')}</h2>
                <div className="person-basic-information-form">
                    <FieldHidden name="id" ref="field_id" value={this.props.person['Person']['id']}/>

                    {personFields}

                    <div className="clearfix"></div>

                    <div className="form-validation-errors"></div>

                    <div className="form-actions">
                        <a className="ui button save" href="#" role="button" onClick={preventDef(this.save.bind(this))}>{__d('people','Save')}</a>
                    </div>
                </div>
            </div>
        );
    }
}

EditProfileBasicInformation.propTypes= {
    person: PropTypes.object.isRequired,
    moduleSettings: PropTypes.object.isRequired
};

EditProfileBasicInformation.defaultProps= {
        fieldRefs: [
            'id',
            'title',
            'firstname',
            'middlename',
            'lastname',
            'maidenname',
            'nickname',
            'email',
            'suffix',
            'gender',
            'birthday',
            'marital_status',
            'wedding_anniversary',
            'shirt_size'
        ]
};


class PeopleReactModulesEditProfile extends React.Component{
    constructor(props){
        super(props);
    }
    render() {
        var person = this.props.person;

        return (
            <div className="people-edit-profile-form-holder">
                <EditProfileBasicInformation person={person} moduleSettings={this.props.moduleSettings}/>

                {parseInt(this.props.moduleSettings.show_address_fields) ?
                    <EditProfileAddresses addresses={person.PersonAddress}
                                          personId={person.Person.id}
                                          moduleSettings={this.props.moduleSettings}/> : undefined}

                {parseInt(this.props.moduleSettings.show_phone_fields) ?
                    <EditProfilePhones phones={person.PersonPhone}
                                       personId={person.Person.id}
                                       moduleSettings={this.props.moduleSettings}/> : undefined}

                {parseInt(this.props.moduleSettings.show_social_network_fields) ?
                    <EditProfileSocialNetworks socialNetworks={person.PersonSocialNetwork}
                                               personId={person.Person.id}
                                               moduleSettings={this.props.moduleSettings}/> : undefined}

                {parseInt(this.props.moduleSettings.show_instant_messenger_fields) ?
                    <EditProfileInstantMessengers instantMessengers={person.PersonInstantMessenger}
                                                  personId={person.Person.id}
                                                  moduleSettings={this.props.moduleSettings}/> : undefined}
            </div>
        );
    }
}

PeopleReactModulesEditProfile.propTypes= {
    person: PropTypes.object.isRequired,
        moduleSettings: PropTypes.object.isRequired
};